<template>
    <aside class="post__aside">
        <template v-if="isTab">
            <post-user-tabs
                :user="post.user"
                :pet="post.happy_postable"
            />
        </template>
        <template v-else>
            <div class="post__aside-card">
                <post-user :user="post.user" />
            </div>
        </template>
        <div class="post__aside-card mt-4 d-none d-lg-block">
            <post-categories :categories="categories" />
        </div>
    </aside>
</template>

<script>

import PostUser from './PostUser'
import PostCategories from './PostCategories'
import PostUserTabs from './PostUserTabs'

export default {
    name: "PostAside",
    components: { PostUser, PostCategories, PostUserTabs },
    props: {
        post: { required: true, type: Object },
        categories: { required: true, type: Array }
    },

    computed:{
        isTab(){
            const { happy_type, happy_id } = this.post
            return happy_type && happy_id
        }
    }

}
</script>